import BattleActions from '../battle-data/battle-actions.js'
import {randomFromArray} from '../../helpers/random-from-array.js'
//Super
import {getBotSuperDecision} from './get-bot-super-decision'
//Obvious Opportunities
import {getBotObviousOpportunityDecision} from './get-bot-obvious-opportunity-decision'
//Paths
import {getRegularPath} from './personality-paths/get-regular-path.js'
import {getViciousPath} from './personality-paths/get-vicious-path.js'
import {getRecoverPath} from './personality-paths/get-recover-path.js'
import {getCursingPath} from './personality-paths/get-cursing-path.js'
import {getCleaningPath} from './personality-paths/get-cleaning-path.js'
import {getBoostingPath} from './personality-paths/get-boosting-path.js'
import {getThiefPath} from './personality-paths/get-thief-path.js'
import {getSlowingPath} from './personality-paths/get-slowing-path.js'




export function getSmartDecision(casterModel, teamCombatants=[], enemyCombatants=[], personalityOptions=[]) {




  //Create array of all caster's actions in model form
  const casterActions = casterModel.getAvailableActions() //Note: contains PP check, and only Supers if DM is available
    .map(action => {
      return {
        id: action.actionId,
        ...BattleActions[action.actionId],
        actionMeta: action //includes actionId and instanceId, isStolen, etc
      }
    });

  //First, Figure out if we're going to use a Super move here.. (that will bypass the personality stuff)
  const superAttacks = casterActions.filter(a => a.isSuper); //These will only show up if danger meter is ready
  if (superAttacks.length) {
    //Pick a random one to use.
    const validSuperAttack = getBotSuperDecision(casterModel, teamCombatants, enemyCombatants, superAttacks)
    if (validSuperAttack) {
      return {
        wasSuccessful: true,
        personalityUsed: "super", //TODO: Not really used for successes, but might be useful to know?
        actionModel: validSuperAttack.actionModel,
        casterModel: validSuperAttack.casterModel,
        targetModels: validSuperAttack.targetModels
      }
    }
  }

  //Next, Now check for the "obvious" opportunities
  // -> These are things like "do I have a move that will do extra damage against person X?" Like, Scope Bomb on a Deadline
  const obviousOpportunityDecision = getBotObviousOpportunityDecision(casterModel, teamCombatants, enemyCombatants, casterActions);
  if (obviousOpportunityDecision) {
    return {
      wasSuccessful: true,
      personalityUsed: "obvious-decision", //TODO: Again, not really used for successes, but might be useful to know
      actionModel: obviousOpportunityDecision.actionModel,
      casterModel: obviousOpportunityDecision.casterModel,
      targetModels: obviousOpportunityDecision.targetModels
    }
  }

  //If no decision so far, figure out which personality path we will attempt
  const chosenPersonality = personalityOptions.length
    ? randomFromArray(personalityOptions)
    : "regular"; //default if out of options

  const personalityMap = {
    "regular": getRegularPath,
    "vicious": getViciousPath,
    "recovering": getRecoverPath,
    "cursing": getCursingPath,
    "cleaning": getCleaningPath,
    "boosting": getBoostingPath,
    "thief": getThiefPath,
    "slowing": getSlowingPath,
  };

  if (!personalityMap[chosenPersonality]) {
    console.warn('personality path not found in personalityMap', chosenPersonality);
  }

  let decision = personalityMap[chosenPersonality](casterModel, teamCombatants, enemyCombatants, casterActions);
  //null or { actionModel:{} casterModel:casterModel, targetModels: [{}, {}] }

  return decision ? {
    wasSuccessful: true,
    personalityUsed: chosenPersonality,
    actionModel: decision.actionModel,
    casterModel: decision.casterModel,
    targetModels: decision.targetModels
  } : {
    wasSuccessful: false,
    personalityUsed: chosenPersonality,
  }
}


/* Output -> one of two types
Case 1: Success Model
  {
     wasSuccessful: true,
     personalityUsed: "string",
     actionModel: {},
     casterModel: {},
     targetModels: [{}]
  }

Case 2: Fail Model
 {
   wasSuccessful: false,
   personalityUsed: "string",
 }
*/


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-smart-decision.js